import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ baseURL: API });

export const api = {
  status: () => http.get("/bot/status").then((r) => r.data),
  guilds: () => http.get("/bot/guilds").then((r) => r.data),
  guild: (id) => http.get(`/bot/guilds/${id}`).then((r) => r.data),
  join: (id, channel_id) => http.post(`/bot/guilds/${id}/join`, { channel_id }).then((r) => r.data),
  play: (id, body) => http.post(`/bot/guilds/${id}/play`, body).then((r) => r.data),
  control: (id, action) => http.post(`/bot/guilds/${id}/control`, { action }).then((r) => r.data),
  loop: (id, mode) => http.post(`/bot/guilds/${id}/loop`, { mode }).then((r) => r.data),
  volume: (id, value) => http.post(`/bot/guilds/${id}/volume`, { value }).then((r) => r.data),
  seek: (id, value) => http.post(`/bot/guilds/${id}/seek`, { value }).then((r) => r.data),
  skipto: (id, value) => http.post(`/bot/guilds/${id}/skipto`, { value }).then((r) => r.data),
  move: (id, frm, to) => http.post(`/bot/guilds/${id}/move`, { frm, to }).then((r) => r.data),
  remove: (id, index) => http.delete(`/bot/guilds/${id}/queue/${index}`).then((r) => r.data),
  stay: (id, enabled) => http.post(`/bot/guilds/${id}/247`, { enabled }).then((r) => r.data),
  history: (guild_id) => http.get("/bot/history", { params: { guild_id } }).then((r) => r.data),
  search: (q, source) => http.get("/search", { params: { q, source } }).then((r) => r.data),
};

export const errMsg = (e) => e?.response?.data?.detail || e.message || "Błąd";

export const fmt = (ms = 0) => {
  const s = Math.floor(ms / 1000);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = String(s % 60).padStart(2, "0");
  return h ? `${h}:${String(m).padStart(2, "0")}:${sec}` : `${m}:${sec}`;
};
